import { render, staticRenderFns } from "./WidgetSettingsHeaderForm.vue?vue&type=template&id=3d40128e"
import script from "./WidgetSettingsHeaderForm.vue?vue&type=script&lang=js"
export * from "./WidgetSettingsHeaderForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports